import _ from 'lodash';
import moment from 'moment-timezone'



const canConfirmSelectedSalesOrder = (state) =>{
  if(state.selectedSalesOrder==null) return false;

  return (state.selectedSalesOrder.status.code==="DRAFT" && state.selectedSalesOrder.invalid==false ||
          state.selectedSalesOrder.status.code=="VOIDED");
}

const isInvoiceMultipleSalesOrderEnable = () => {
  return process.env.INVOICE_MULTIPLE_ENABLE !== 'FALSE'
}

const canInvoicedSelectedSalesOrder = (state) => (vm) => {
  const statusCode = _.get(state.selectedSalesOrder, 'status.code');
  if(state.selectedSalesOrder==null)return false;
  if(statusCode=='DRAFT') return false;

  let invoiced = false;
  let nbInvoice = 0;
  if(state.selectedSalesOrder.invoices!=null){
    nbInvoice = state.selectedSalesOrder.invoices.length;
    _.forEach(state.selectedSalesOrder.invoices, i=>{
      if(i.status.code!="VOIDED"){
        invoiced=true;
      }
    })
  }


  return (statusCode !== "DRAFT" &&
          statusCode !== "VOIDED" &&
          statusCode != "TO_PROCESS" &&
         !invoiced &&
         vm.$can('write','Invoices'))
}

const canReturnToDraft = (state, getters, rootState, rootGetters) => (vm) => {

  const status = _.get(state.selectedSalesOrder, 'status');
  if (status == null ) return false;

  // S'il y a un processus de traitement automatique on empeche le changement de statut.
  let packageProcessedAuto = false;
  _.forEach(state.selectedSalesOrder.packages, pack => {
    if (pack.externalStatus != null) {
      packageProcessedAuto = true;
    }
  })
  
  if (status.code === 'IN_AUTO_PROCESS' || packageProcessedAuto === true) {
    return false;
  }

  return (vm.$can('write','SalesOrders') && (status.code=="TO_PROCESS" || status.code=="VOIDED")) ||
        (vm.$can('manage','SalesOrders') && status.code!=="DRAFT" && status.code!=="DRAFT_EXTERNAL") &&
        state.selectedSalesOrder.invoicedAt == null;

}

const canReturnToConfirmed = (state) => (vm) =>{
  const status = _.get(state.selectedSalesOrder, 'status');
  if (status == null ) return false;

  // S'il y a un processus de traitement automatique on empeche le changement de statut.
  let packageProcessedAuto = false;
  _.forEach(state.selectedSalesOrder.packages, pack => {
    if (pack.externalStatus != null) {
      packageProcessedAuto = true;
    }
  })
  if (status.code === 'IN_AUTO_PROCESS' || packageProcessedAuto === true) {
    return false;
  }

  return (vm.$can('manage','SalesOrders') && status.weight >= 20) // IN_PROCESS
}


const canCancelSelectedSalesOrder = (state) => (vm)=> {
  const status = _.get(state.selectedSalesOrder, 'status');
  if (status == null ) return false;

  return (vm.$can('write','SalesOrders') && (status.code=="TO_PROCESS" || status.code=="DRAFT")) ||
        (vm.$can('manage','SalesOrders') && status.code!=="VOIDED");
}
const canDeleteSelectedSalesOrder = (state) => (vm) => {
  const status = _.get(state.selectedSalesOrder, 'status');
  if (status == null ) return false;
  return status.code == "VOIDED" && vm.$can('manage','SalesOrders');
}


const canProcessSelectedSalesOrder = (state) =>{
  const status = _.get(state.selectedSalesOrder, 'status');
  if (status == null ) return false;

  return status.code=="INVOICED" ||
         status.code=="CONFIRMED";
}

const canEditSelectedSalesOrder = (state, getters, rootState, rootGetters) => (vm) =>{
  
  const status = _.get(state.selectedSalesOrder, 'status');
  if (status == null ) return false;

  let editable = status.weight < 20 || vm.$can('manage','SalesOrders');

  if (rootGetters.isRepCanModify || rootGetters.isCurrentUserAdmin) {
    return editable;
  } else {
    const ids = [];
    ids.push(_.get(state.selectedSalesOrder, 'createdBy.id'));

    if (_.get(state.selectedSalesOrder, 'rep.id') != null) {
      ids.push(_.get(state.selectedSalesOrder, 'rep.id'))
    }

    const rep = _.find(ids, id => id === rootGetters.getCurrentUserId);
    if (rep == null) {
      editable = false
    }

    return editable;
  }
}

const isRepCanEdit = (state, getters, rootState, rootGetters) => (vm) => {
  if (rootGetters.isRepCanModify) {
    return true;
  }

  const ids = [];
  
  ids.push(_.get(state.selectedSalesOrder, 'createdBy.id'));

  if (_.get(state.selectedSalesOrder, 'rep.id') != null) {
    ids.push(_.get(state.selectedSalesOrder, 'rep.id'))
  }

  const rep = _.find(ids, id => id === rootGetters.getCurrentUserId);
  if (rep == null) {
    return false;
  }

  return true;
}

const selectedSalesOrderConfirmedStatus = (state) => {

  let confirmedStatus = null;
  if(state.selectedSalesOrder!=null){
    confirmedStatus = _.find(state.selectedSalesOrder.statusLogs, status=>{return status.code==="CONFIRMED"});
  }
  return confirmedStatus;
}

const selectedSalesOrderInvoicedStatus = (state) => {

  let invoicedStatus = null;
  if(state.selectedSalesOrder!=null){
    invoicedStatus = _.find(state.selectedSalesOrder.statusLogs, status=>{return status.code==="INVOICED"});
  }
  return invoicedStatus;
}

const selectedSalesOrderVoidedStatus = (state) => {

  let voidStatus = null;
  if(state.selectedSalesOrder!=null){
    voidStatus = _.find(state.selectedSalesOrder.statusLogs, status=>{return status.code==="VOIDED"});
  }
  return voidStatus;
}


const selectedSalesOrderTagType = (state) =>{
  let tagType = '';//Default tagType => CONFIRMED
  if(state.selectedSalesOrder!=null){
    if(state.selectedSalesOrder.status.code==="DRAFT"){
      tagType = "info";
    }else if(state.selectedSalesOrder.status.code==="INVOICED"){
      tagType = "success";
    }else if(state.selectedSalesOrder.status.code==="PACKED"){
      tagType = "warning";
    }else if(state.selectedSalesOrder.status.code==="SHIPPED"){
      tagType = "warning";
    }else if(state.selectedSalesOrder.status.code==="FULLFILLED"){
      tagType = "success";
    }else if(state.selectedSalesOrder.status.code==="CLOSED"){
      tagType = "info";
    }else if(state.selectedSalesOrder.status.code==="VOID"){
      tagType = "danger";
    }
  }
  return tagType;
}

const getOrderBy = (state) =>{
  return state.orderBy;
}

const getSortIcon = (state) =>{
  return state.sort_icon;
}

const getSelectedSalesOrderRemainingQuantities = (state) => (uuid) =>{
  if(state.selectedSalesOrder!=null && state.selectedSalesOrder.status.code=="DRAFT"){
    let calculateItemLine  = _.find(state.selectedSalesOrder.calculation_detail.items, item=>{return item.uuid==uuid});
    return calculateItemLine.remaining_qty;
  }else{
    return null;
  }
}

const customerName = (state) => (customer) =>{
  if(customer==null)return null;
  return customer.usualName!=null?customer.usualName:customer.name;
}

const getCreditItemLineTotal = (state) =>{
  let credit = 0;
  _.forEach(state.selectedSalesOrder.lines, item=>{
    if(item.credit!=null){
      credit+=item.credit;
    }
  })
  return credit;
}

const validateSelectedSalesOrder = (state) => (salesOrder)=>{
  let quantityCheckPassed=true;
  _.forEach(salesOrder.lines, i=>{
    if(i.validations!=null && i.validations.length>0){
      quantityCheckPassed=false;
    }
  })
  return quantityCheckPassed;
}

const getNbFiltersCriteria = (state) => {
  let nb = 0;
  if(state.filters.status.length>0)nb++;
  if(state.filters.date != null)nb++;
  if(state.filters.deliveryDate != null)nb++;
  if(state.filters.checkedCustomerClasses.length>0)nb++;
  if(state.filters.checkedTags.length>0)nb++;
  if(state.filters.checkedReps.length>0)nb++;
  if(state.filters.withoutReps==true)nb++;
  if(state.filters.customerId != null)nb++;
  if(state.filters.productId != null)nb++;
  if(state.filters.inventories.length > 0)nb++;
  return nb;
}

const isFiltered = (state) =>{
  return !(state.filters.status.length == 0 &&
          state.filters.date==null &&
          state.filters.deliveryDate==null &&
          state.filters.checkedCustomerClasses.length==0 &&
          state.filters.checkedTags.length==0 &&
          state.filters.checkedReps.length==0 &&
          state.filters.withoutReps==false &&
          state.searchTerms=='' &&
          state.filters.customerId==null &&
          state.filters.productId == null &&
          state.filters.inventories.length == 0
        )
}

const fetchParams = (state) => {
  let params = {};
  // params.paging='no';
  params.orderBy = state.orderBy.orderName;
  params.direction = state.orderBy.direction;
  params.searchTerms = state.searchTerms;
  params.limit = state.limit;
  params.page = state.page;

  params.startDate = state.filters.date ? moment(state.filters.date[0]).format("YYYY-MM-DD Z") : undefined;
  params.endDate = state.filters.date ? moment(state.filters.date[1]).format("YYYY-MM-DD Z") : undefined;

  params.startDeliveryDate = state.filters.deliveryDate ? moment(state.filters.deliveryDate[0]).format("YYYY-MM-DD Z") : undefined;
  params.endDeliveryDate = state.filters.deliveryDate ? moment(state.filters.deliveryDate[1]).format("YYYY-MM-DD Z") : undefined;

  params.productId = state.filters.productId != null ? state.filters.productId : undefined;
  params.customerId = state.filters.customerId != null ? state.filters.customerId : undefined;

  if(state.filters.deliveryType!=null && state.filters.deliveryType.length>0){
    params.deliveryTypeId = [];
    _.forEach(state.filters.deliveryType, type =>{
        params.deliveryTypeId.push(type.id);
    })
  }

   params.inventoryId = [];
  _.forEach(state.filters.inventories, i => {
    params.inventoryId.push(i.id);
  })

  if(state.filters.withoutReps){
    params.withoutReps=true;
  }

  params.repId=[];
  _.forEach(state.filters.checkedReps, r=>{
   params.repId.push(r);
  })

  if(state.filters.checkedTags.length>0){
    params.tagId = [];
    _.forEach(state.filters.checkedTags, t=>{
      params.tagId.push(t);
    })
  }

  params.customerClassId=[];
   _.forEach(state.filters.checkedCustomerClasses, c=>{
    params.customerClassId.push(c);
   })

  params.statusId = state.filters.status?state.filters.status:undefined;
  params.origin = state.filters.origin?state.filters.origin:undefined;
  params.startDate = state.filters.date?state.filters.date[0]:undefined;
  params.endDate = state.filters.date?state.filters.date[1]:undefined;

  return params;
}

const isSelectedSalesOrderQuantitiesValid = (state) => {
    let valid = true;
    if (_.isEmpty(state.selectedSalesOrder.lines)) return valid;
    _.forEach(state.selectedSalesOrder.lines, l => {
      if (l.quantityAvailable === false) valid = false;
    })
    return valid;
}

const extractExternalResultItems = (externalResult) => {
  if (externalResult == null) return [];
  if (_.isString(externalResult)) {
    try { externalResult = JSON.parse(externalResult); } catch (e) { return []; }
  }
  if (_.isArray(externalResult)) return externalResult;
  if (_.isArray(externalResult.items)) return externalResult.items;
  if (_.isArray(externalResult.produits)) return externalResult.produits;
  if (_.isArray(externalResult.products)) return externalResult.products;
  if (_.isArray(externalResult.lines)) return externalResult.lines;
  if (externalResult.produit != null || externalResult.product != null) return [externalResult];
  return [];
}

const getReferenceSuffix = (line) => {
  const ref = _.get(line, 'product.item.reference');
  if (ref == null) return null;
  const parts = String(ref).split('-');
  return _.last(parts);
}

const matchInvalidUvcItemToLine = (item, lines) => {
  const produitCode = _.get(item, 'produit', _.get(item, 'product'));
  if (produitCode == null) return null;
  return _.find(lines, l => getReferenceSuffix(l) === String(produitCode)) || null;
}

const buildInvalidUvcItems = (externalResult, lines) => {
  const items = extractExternalResultItems(externalResult);
  return _.map(items, item => {
    const matchedLine = matchInvalidUvcItemToLine(item, lines);
    const produitCode = _.get(item, 'produit', _.get(item, 'product'));
    return {
      produit: produitCode,
      quantiteModulo: _.get(item, 'quantiteModulo'),
      productNumber: _.get(matchedLine, 'product.item.reference', produitCode),
      productName: _.get(matchedLine, 'product.name')
        || _.get(matchedLine, 'product.item.name')
        || _.get(matchedLine, 'name'),
      lineUuid: _.get(matchedLine, 'uuid'),
      linePuid: _.get(matchedLine, 'puid'),
    };
  });
}

const getExternalRejectedCodes = (state) => {
    const rejectedReason = [];
    const lines = _.get(state, 'selectedSalesOrder.lines', []);
    _.forEach(_.get(state, 'selectedSalesOrder.packages'), pack => {
      if (pack.externalRejectReason != null) {
        const entry = {
          reason: pack.externalRejectReason,
          commentaries: pack.commentaries,
          externalResult: pack.externalResult,
        };
        if (pack.externalRejectReason === 'PRODUCT_INVALID_UVC') {
          entry.invalidUvcItems = buildInvalidUvcItems(pack.externalResult, lines);
        }
        rejectedReason.push(entry);
      }
    })
  return rejectedReason;
}

const hasExternalRejectedCodes = (state, getters) => {
  return _.size(getters.getExternalRejectedCodes) > 0;
}

const getInvalidUvcProductCodes = (state, getters) => {
  const codes = [];
  _.forEach(getters.getExternalRejectedCodes, rej => {
    if (rej.reason !== 'PRODUCT_INVALID_UVC') return;
    _.forEach(rej.invalidUvcItems, item => {
      if (item.produit != null) codes.push(String(item.produit));
    });
  });
  return _.uniq(codes);
}

const isLocationInvalid = (state) => {
  return (_.get(state.selectedSalesOrder, 'deliveryType.invalidLocation') === true && _.get(state.selectedSalesOrder, 'status.weight') <= 10);
}

const isInProblem = (state, getters) => {
  return !getters.isSelectedSalesOrderQuantitiesValid(state) || getters.isLocationInvalid(state)
}

export default {
  getExternalRejectedCodes,
  hasExternalRejectedCodes,
  getInvalidUvcProductCodes,
  isSelectedSalesOrderQuantitiesValid,
  selectedSalesOrderTagType,
  selectedSalesOrderConfirmedStatus,
  selectedSalesOrderInvoicedStatus,
  selectedSalesOrderVoidedStatus,
  canConfirmSelectedSalesOrder,
  canEditSelectedSalesOrder,
  getOrderBy,
  getSortIcon,
  getSelectedSalesOrderRemainingQuantities,
  canCancelSelectedSalesOrder,
  canDeleteSelectedSalesOrder,
  canInvoicedSelectedSalesOrder,
  customerName,
  canReturnToDraft,
  getCreditItemLineTotal,
  canReturnToConfirmed,
  validateSelectedSalesOrder,
  getNbFiltersCriteria,
  isFiltered,
  fetchParams,
  isInvoiceMultipleSalesOrderEnable,
  isInProblem,
  isLocationInvalid,
  isRepCanEdit,
};
